export const PENN_DOT_BLUE = "#013F7E";
export const PENN_DOT_BLUE_LIGHT = "#9accfe";
export const PENN_DOT_BLUE_DARK = "#01264c";
export const PENN_DOT_GREEN = "#00853E";
export const PENN_DOT_GREEN_LIGHT = "#b3ffd6";
export const PENN_DOT_GREEN_DARK = "#004d24";

export const GREY_1 = "#d5d5d5";
export const GREY_BACKGROUND = "#f5f5f5";

export const INPUT_BORDER = "#a5a5a5";

export const ALERT = "#d32f2f";
